// src/store/reducer/wishlistSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { joinWishlist } from '../thunk/wishlistThunk';

const initialState = {
    // joinWishlist state
    joinLoading: false,
    joinError: null,
    joinSuccess: false,
    joinData: null,         // { id, is_new } from backend on success
};

const wishlistSlice = createSlice({
    name: 'wishlist',
    initialState,
    reducers: {
        /** Call this when the modal is closed to reset state for next open */
        resetWishlistState: (state) => {
            state.joinLoading = false;
            state.joinError = null;
            state.joinSuccess = false;
            state.joinData = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(joinWishlist.pending, (state) => {
                state.joinLoading = true;
                state.joinError = null;
                state.joinSuccess = false;
                state.joinData = null;
            })
            .addCase(joinWishlist.fulfilled, (state, action) => {
                state.joinLoading = false;
                state.joinSuccess = true;
                state.joinData = action.payload?.data || null;
            })
            .addCase(joinWishlist.rejected, (state, action) => {
                state.joinLoading = false;
                state.joinError = action.payload || 'Something went wrong.';
            });
    },
});

export const { resetWishlistState } = wishlistSlice.actions;

export default wishlistSlice.reducer;

// ── Selectors ──────────────────────────────────────────────
export const selectWishlistJoinLoading  = (state) => state.wishlist.joinLoading;
export const selectWishlistJoinError    = (state) => state.wishlist.joinError;
export const selectWishlistJoinSuccess  = (state) => state.wishlist.joinSuccess;
export const selectWishlistJoinData     = (state) => state.wishlist.joinData;
